<template>
  <div>
    <Head title="Grupos de atendimento" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Grupos de atendimento</h1>
      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="groups/list"
        no-data-label="Nenhum grupo cadastrado"
        no-result-label="Nenhum grupo encontrado"
      >
        <template #table.cell.content.group_status="{ value, row }">
          <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>
        <template #grid.content.body.group_status="{ value, row }">
          <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>

        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 ">
            <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
            <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 ">
            <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
            <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
          </div>
        </template>

        <template #after.reload-button>
          <button class="flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="openModalEdit({})">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block"> Adicionar Grupo de Atendimento</span>
          </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
    <modal-edit ref="modalEdit" title="Grupo de Atendimento" url="groups" @submitForm="reloadTable">
      <template #form="{item}">
        <text-input v-model="item.name" :error="item.errors.name" class="lg:pr-6 w-full lg:w-3/4" label="Nome" />
        <switch-input v-model="item.status" class="w-full mt-6 lg:mt-0 lg:w-1/4" label="Situação" labelChecked="Ativo" labelUnchecked="Inativo" />
      </template>
    </modal-edit>
  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import DataTable from '@/Shared/DataTable'
import SwitchInput from '@/Shared/SwitchInput'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    DataTable,
    SwitchInput,
    TextInput,
  },
  layout: Layout,
  setup() {

  },
  data() {
    return {
      loadTable: true,
      columns: [
        {
          uniqid: 'group_name',
          label: 'Nome do grupo',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'group_status',
          label: 'Situação',
          field: 'status',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    changeStatus(item) {
      item.status = !item.status;
      this.$inertia.post("/groups/update-status", item);
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/groups/${item.id}`, `Deseja realmente excluir o grupo ${item.name}?`);
    },
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        name: item.name,
        status: item.status ?? true,
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    }
  },
}
</script>